import { Box, Typography } from '@mui/material';
import MotiveWebReport from 'features/motive/motive-web-report/motive-web-report';
import React from 'react';
import { useParams } from 'react-router';

const MotiveWebReportPage: React.FC = () => {
  const { token } = useParams();

  if (!token) {
    return (
      <Box padding={3}>
        <Typography variant="h5">Missing report token</Typography>
        <Typography color="textSecondary">Please open the report using a valid link.</Typography>
      </Box>
    );
  }

  return <MotiveWebReport token={token} />;
};

export default MotiveWebReportPage;
